import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { EventComponent } from './event/event.component';
import { EventsComponent } from './events/events.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ShareButtonsConfig, ShareModule } from '@ngx-share/core';
import { FormsModule } from '@angular/forms';
import { NotificationsComponent } from './notifications/notifications.component';

const customConfig: ShareButtonsConfig = {
  autoSetMeta: true,
  twitterAccount: ''
};
@NgModule({
  declarations: [HomeComponent, EventComponent, EventsComponent, NotificationsComponent],
  imports: [
    CommonModule,
    SharedModule,
    FontAwesomeModule,
    NgbModule,
    FormsModule,
    ShareModule.withConfig(customConfig),
    SlickCarouselModule,
    RouterModule.forChild([
      { path: 'events' , component: EventsComponent},
      { path: 'event/:id' , component: EventComponent},
      { path: 'notifications/:id' , component: NotificationsComponent},
    ])
  ],
  exports: [
    HomeComponent,
    SlickCarouselModule
  ]
})
export class SiteModule { }
